import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.black,
  },
  title_container: {
    width: '100%',
    paddingTop: 10,
  },
  title_top: {
    fontSize: 18,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  button_container: {
    width: '100%',
    paddingBottom: 20,
  },
  title_bottom: {
    fontSize: 16,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  body: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title_body: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  action: {
    paddingTop: 20,
    width: '100%',
    maxWidth: 350,
  },
  body_button: {
    backgroundColor: colors.white,
    borderRadius: 4,
    padding: 10,
  },
  title_action: {
    fontSize: 22,
    fontWeight: '700',
    color: appTheme.textColor,
    textAlign: 'center',
  },
  input: {
    marginVertical: 12,
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: colors.white,
    color: colors.black,
    padding: 10,
  },
  password_container: {
    marginBottom: 12,
  },
  password_title: {
    color: colors.red,
    textAlign: 'center',
    fontSize: 20,
    fontWeight: '700',
  },
});
